window.openTaskCreatorModal = function(url) {
  var modalFrame = document.querySelector('turbo-frame#modal_frame');
  if (!modalFrame) return;
  var logoUrl = document.querySelector('meta[name="writingio-logo"]')?.content || '';
  var logoHtml = logoUrl ? '<div class="text-center mb-4"><img src="' + logoUrl + '" alt="Writing.io" style="max-height: 36px;"></div>' : '';
  var tips = [
    { icon: 'fad fa-brain', title: 'Advanced Reasoning', desc: 'Your tasks can use AI reasoning to think through complex problems step-by-step before giving you an answer.' },
    { icon: 'fad fa-globe', title: 'Live Web Search', desc: 'Need current info? Tasks can search the web for the latest data, news, and trends while they run.' },
    { icon: 'fad fa-clock', title: 'Scheduled Automation', desc: 'Run any task on a schedule — daily, weekly, or monthly. Results are delivered straight to your documents.' },
    { icon: 'fad fa-file-circle-plus', title: 'File Attachments', desc: 'Attach PDFs, images, or documents to give your task more context and get better, tailored results.' },
    { icon: 'fad fa-star', title: 'Quick Access Favorites', desc: 'Star the tasks you use most and they\'ll appear front and center on your AI Chat dashboard.' },
    { icon: 'fad fa-pen-to-square', title: 'Fully Customizable', desc: 'Every task is yours to edit. Adjust the prompt, add instructions, or tweak settings to fit your workflow.' },
  ];
  var tip = tips[Math.floor(Math.random() * tips.length)];
  modalFrame.innerHTML = '<div class="library-task-creator-modal">' +
    '<button type="button" class="library-task-creator-modal-close" onclick="this.closest(\'.library-task-creator-modal\').remove()"><i class="fas fa-times"></i></button>' +
    '<div class="library-task-creator-modal-body">' +
    logoHtml +
    '<div id="modal_content"><div class="text-center p-5">' +
    '<div class="spinner-border mb-4" role="status"></div>' +
    '<p class="font-size-18 font-weight-bold mb-2">Loading...</p>' +
    '<div class="task-loading-tip mt-5">' +
    '<div class="tip-icon-circle mb-3"><span class="' + tip.icon + '"></span></div>' +
    '<p class="font-size-16 font-weight-bold mb-2">' + tip.title + '</p>' +
    '<p class="font-size-15 opacity-6 mb-0" style="max-width: 360px; margin: 0 auto;">' + tip.desc + '</p>' +
    '</div></div></div></div>';
  fetch(url, { headers: { 'Accept': 'text/html', 'Turbo-Frame': 'modal_content' } })
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var content = doc.querySelector('turbo-frame#modal_content') || doc.querySelector('#modal_content');
      var target = document.getElementById('modal_content');
      if (content && target) { target.innerHTML = content.innerHTML; }
      else if (target) { target.innerHTML = html; }
    });
}
